var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircularProgress = function SvgCircularProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 250 250"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 115,
    fill: "none",
    stroke: "#ddd",
    strokeWidth: 20
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 115,
    fill: "none",
    stroke: "#5394fd",
    strokeWidth: 20,
    strokeDasharray: "361.25 361.25"
  })));
};
export default SvgCircularProgress;